const getInvoiceOtherDetails = (invoiceData) => {
  const rawDetails = invoiceData?.other_details;
  if (!rawDetails) return null;

  try {
    return typeof rawDetails === 'string' ? JSON.parse(rawDetails) : rawDetails;
  } catch {
    return null;
  }
};

export const getInvoiceBillingProvider = (invoiceData) => getInvoiceOtherDetails(invoiceData)?.billing_provider || null;

// Visit date (YYYY-MM-DD) the patient picked when booking lab tests online.
export const getInvoiceVisitDate = (invoiceData) => getInvoiceOtherDetails(invoiceData)?.online_booking?.scheduled_date || null;

export const getInvoiceInsurerName = (invoiceData) => {
  const provider = getInvoiceBillingProvider(invoiceData);
  return provider?.type === 'insurance' ? provider.insurer_name || null : null;
};

export const getInvoiceBillingProviderValue = (invoiceData) => {
  const provider = getInvoiceBillingProvider(invoiceData);
  return provider?.type === 'insurance' && provider.policy_id
    ? String(provider.policy_id)
    : 'self';
};

export const getAdmissionsFromResponse = (response) => {
  const admissions = response?.results || response?.admissions || response || [];
  return Array.isArray(admissions) ? admissions : [];
};

export const getDefaultBillingProvider = ({ value, policies, hasActiveAdmission }) => {
  const availablePolicies = Array.isArray(policies) ? policies : [];
  const currentProviderIsAvailable = value === 'self' || availablePolicies.some(
    (policy) => String(policy.id) === String(value)
  );
  if (currentProviderIsAvailable) return value;
  if (hasActiveAdmission && availablePolicies.length > 0) {
    return String(availablePolicies[0].id);
  }
  return 'self';
};
